// ============================================================================
// ClipboardContext — shared calendar copy/paste clipboard.
// Mounted above the Programs and Calendar routes so a copied snapshot survives
// navigation between views (copy in a program, paste in an athlete calendar).
// ============================================================================

import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'
import type { CalendarClipboard } from '@/types/calendar'

interface ClipboardContextValue {
  clipboard: CalendarClipboard | null
  setClipboard: (clipboard: CalendarClipboard | null) => void
}

const ClipboardContext = createContext<ClipboardContextValue>({
  clipboard: null,
  setClipboard: () => {},
})

export function ClipboardProvider({ children }: { children: ReactNode }) {
  const [clipboard, setClipboard] = useState<CalendarClipboard | null>(null)
  return (
    <ClipboardContext.Provider value={{ clipboard, setClipboard }}>
      {children}
    </ClipboardContext.Provider>
  )
}

export function useClipboard() {
  return useContext(ClipboardContext)
}
